import { render, staticRenderFns } from "./JobRequirementDetails.vue?vue&type=template&id=79154324"
import script from "./JobRequirementDetails.vue?vue&type=script&lang=js"
export * from "./JobRequirementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports